import { render, staticRenderFns } from "./summary-backoffice.vue?vue&type=template&id=2a6a17a9&"
import script from "./summary-backoffice.vue?vue&type=script&lang=js&"
export * from "./summary-backoffice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/lang/defaults-i18n.yaml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fweb%2Fsrc%2Fcomponents%2Ftasks%2Fcommon%2Fsummary%2Fregistration%2Fsummary-backoffice.vue"
if (typeof block0 === 'function') block0(component)
import block1 from "./summary-backoffice-i18n.yaml?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fweb%2Fsrc%2Fcomponents%2Ftasks%2Fcommon%2Fsummary%2Fregistration%2Fsummary-backoffice.vue"
if (typeof block1 === 'function') block1(component)

export default component.exports